/**
 * Paths allowed while OAuth onboarding is pending (matches mobile + backend guard).
 */
import { parseSafeRedirectPath } from '@/shared/utils/authRedirect.util';

const OAUTH_ONBOARDING_ALLOWED_SEGMENTS = [
  '/auth/oauth/complete-setup',
  '/auth/onboarding/status',
  '/privacy/',
  '/auth/refresh-token',
  '/auth/logout',
  '/auth/signin',
  '/auth/complete-registration',
  '/auth/login/methods',
];

export function isAllowedDuringOAuthOnboarding(requestUrl) {
  const normalized = (requestUrl || '').toLowerCase();
  return OAUTH_ONBOARDING_ALLOWED_SEGMENTS.some((segment) => normalized.includes(segment));
}

/**
 * @param {import('vue-router').Router} router
 * @param {string|null} [redirectPath]
 */
export function redirectToCompleteRegistration(router, redirectPath = null) {
  if (router.currentRoute.value?.name === 'auth1.complete-registration') {
    return;
  }
  const fromQuery = router.currentRoute.value?.query?.redirect;
  const safeRedirect =
    parseSafeRedirectPath(redirectPath) ||
    parseSafeRedirectPath(fromQuery);
  const query = safeRedirect ? { redirect: safeRedirect } : {};
  router.replace({ name: 'auth1.complete-registration', query });
}

const OAUTH_POST_LOGIN_REDIRECT_KEY = 'oauthPostLoginRedirect';

/** Preserve ?redirect= across the Google OAuth full-page round trip. */
export function storeOAuthPostLoginRedirect(redirectPath) {
  const safe = parseSafeRedirectPath(redirectPath);
  if (safe) {
    sessionStorage.setItem(OAUTH_POST_LOGIN_REDIRECT_KEY, safe);
  }
}

/** @returns {string|null} */
export function consumeOAuthPostLoginRedirect() {
  const stored = sessionStorage.getItem(OAUTH_POST_LOGIN_REDIRECT_KEY);
  sessionStorage.removeItem(OAUTH_POST_LOGIN_REDIRECT_KEY);
  return parseSafeRedirectPath(stored);
}
